import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { ExistingRoomI18nEditQuery } from "./query";

type Props = {
	hotelID: string;
	roomID: string;
	lang: LangCode;
};

export const useRoomI18nEditQuery = ({ hotelID, roomID, lang }: Props) => {
	const { data } = useCustomSuspenseQuery(ExistingRoomI18nEditQuery, {
		variables: { hotelID, roomID, lang },
	});

	return data;
};
